import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkSetSignerSecurityLevel } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import {
	useTranslationDefault,
	useTranslationMipManage,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { DocumentSigningSecurityLevel } from '@dealstack/shared/lib/generated';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';
import { createSignerMutationErrorHandler } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/api/signerMutationError';

export const useBulkSetSignerSecurityLevel = () => {
	const tMipManage = useTranslationMipManage();
	const tDefault = useTranslationDefault();
	const queryClient = useQueryClient();
	const { dealId, mipId, documentWorkflowInstanceId } = useRequiredParams(
		'dealId',
		'mipId',
		'documentWorkflowInstanceId'
	);

	return useMutation({
		mutationFn: async ({
			roleIds,
			securityLevel,
		}: {
			roleIds: string[];
			securityLevel: DocumentSigningSecurityLevel | null;
		}) => {
			return await bulkSetSignerSecurityLevel(dealId, mipId, documentWorkflowInstanceId, {
				roleIds,
				securityLevel,
			});
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({
				queryKey: [
					formatUnicorn(
						API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_DOCUMENTWORKFLOWINSTANCEID_GET,
						{ dealId, programmeId: mipId, documentWorkflowInstanceId }
					),
				],
			});
			showToastV2({
				title: tMipManage('documents_page.signer.toast.simple_sign_updated'),
			});
		},
		onError: createSignerMutationErrorHandler(tDefault),
	});
};
